import { useOrgSettings } from 'components/OrgSelector/useOrgSettings.js';
import { EVENTS } from 'constants/scopes.js';

const DEFAULT_PLAYER_VERSION = 1;

const usePlayerVersion = () => {
  const { events: eventsSettingsInOrgSettings } = useOrgSettings([EVENTS]);
  const rawPlayerVersion = eventsSettingsInOrgSettings?.defaultSettings?.public?.playerVersion;

  let dashboardPlayerVersion = DEFAULT_PLAYER_VERSION;

  // The following code is based by the code introduced in
  // https://gitlab.bambuser.com/livecommerce/livecommerce-firebase/-/commit/9159b691bbbd5d094f03d48377389dafcebe3260
  if (typeof rawPlayerVersion === 'string') {
    try {
      // Build a list of candidates: [ playerVersion, criteria ]
      const candidates = rawPlayerVersion
        .split(',')
        .filter((c) => c.match(/^\d+:.+$/)) // assume pairs of X:Y
        .map((c) => c.split(':').map((v, i) => (i === 0 ? Number(v) : v))) // cast the first part to a Number
        .filter((c) => c.length === 2) // sanity check
        .filter(([v]) => v > 0) // sanity check
        .sort(([v1], [v2]) => v2 - v1); // sort by playerVersion descending

      // Find the greatest active version
      for (const [playerVersion, criteria] of candidates) {
        if (criteria !== 0 && criteria !== '' && criteria !== '0') {
          dashboardPlayerVersion = playerVersion;
          break;
        }
      }
    } catch (err) {
      // Ok, we'll use the default
    }
  } else if (typeof rawPlayerVersion === 'number' && Number.isFinite(rawPlayerVersion)) {
    dashboardPlayerVersion = rawPlayerVersion;
  }

  return { rawPlayerVersion, dashboardPlayerVersion };
};

export default usePlayerVersion;
